module.exports = __webpack_public_path__ + "img/hospital.d91a8b2d.png";